import MemberTree from "@/views/MGT/member/components/member-tree.vue";
import MemberList from "@/views/MGT/member/components/member-list.vue";
export default {
  name: "member",
  components: {
    MemberTree,
    MemberList
  },
  data() {
    return {
      loading: false,
      node: {},
      searchValue: ""
    };
  },
  methods: {
    onChangeTree(node) {
      this.node = node;
    },
    onSearch(val) {
      this.searchValue = val;
    },
    onChangeLoading(value) {
      this.loading = value;
    }
  }
};